import React from 'react';
import DashboardCard from '../components/Dashboard/DashboardCard';
import Overview from '../components/Dashboard/Overview';
import { Box, Grid } from '@mui/material';
import TopPayable from '../components/Dashboard/TopPayable';
import TopReceiveable from '../components/Dashboard/TopReceiveable';
import TopImportContainerChart from '../components/Dashboard/TopImportContainerChart';
import TopExportContainerChart from '../components/Dashboard/TopExportContainerChart';
import TopPortOfLoading from '../components/Dashboard/TopPortOfLoading';
import TopPortOfDestination from '../components/Dashboard/TopPortOfDestination';
import TopSupplier from '../components/Dashboard/TopSupplier';
import TopCustomer from '../components/Dashboard/TopCustomer';

const Dashboard = () => {
    return (
        <>
            <Box  >
                <DashboardCard />
            </Box>
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid item xs={12} sm={6}>
                    <TopSupplier />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TopCustomer />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TopPayable />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TopReceiveable />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TopImportContainerChart />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TopExportContainerChart />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TopPortOfLoading />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TopPortOfDestination />
                </Grid>
            </Grid>

            <Overview />

        </>
    );
};

export default Dashboard;
